import Cookies from 'js-cookie'

const tokenKey = 'infotikx-token'
const expiresKey = 'infotikx-expires'

export function getToken() {
  return Cookies.get(tokenKey)
}

export function setToken(token) {
  return Cookies.set(tokenKey, token)
}

export function removeToken() {
  sessionStorage.removeItem('userInfo');
  Cookies.remove(tokenKey)
}

//获取SSO过期时间
export function getExpires() {
  return localStorage.getItem(expiresKey)
}
//设置SSO过期时间 单位为分
export function setExpires(expires) {
  return localStorage.setItem(expiresKey, expires)
}
//删除SSO过期时间
export function removeExpires() {
  localStorage.removeItem(expiresKey)
}


// WEBPACK FOOTER //
// ./src/request/token.js